module.exports = __webpack_public_path__ + "media/images/top/search/img_step01-31b8446055e0cffd71201e106d9f29d4.png";